import React from 'react';
import cx from "classnames";
import { Label, Input } from "reactstrap";

const CustomSwitch = ({ label, labelClassName, className, ...rest }) => {
    return ( <label className={cx("custom-input-switch", className)}>
        <input type="checkbox" {...rest} />
        <i />
        {label && <span className={labelClassName}>{label}</span>}
    </label>);
}

CustomSwitch.defaultProps = {
    label: "",
    labelClassName: "ft-1",
    // onClickLabel: () => {}
}
 
export default CustomSwitch;